import React, { useState, useEffect } from 'react';
import ReportFinderForm from './ReportFinderForm';
import History from "../../../History";
import { withStyles, Dialog, CircularProgress, Typography, Paper } from '@material-ui/core';
import * as actions from './store/reportFinderActions';
import { snackActions } from '../../sc-utilities/SnackBar';
import { hasPermission, BackButton, createHistory } from '../../sc-utilities';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import AppLogoLoading from "../../sc-logo";
import { checkIfLoading } from "../../sc-users/User";
import * as reportActions from '../../sc-dashboard/Report/store/reportActions';
import * as groupActions from "../../sc-group/Group/store/groupActions";


const styles = () => ({});

const ReportFinderCreate = props => {
    const { classes, permissions, reportFinder, onClearState, activeCustomerID, onCreateNewReportFinder, onCreateNewXlsCollection, translations, fetchGroups } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });
    const [redirectUrl, setRedirectUrl] = useState('');
    const [groups, setGroups] = useState(null);
    const [loading, setLoading] = useState({ groups: false });


    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return
        }
        setFileToSend({ fileToSend: file, fileName: file.name });
    };

    const redirectHandler = (path) => {
        createHistory(true);
        setRedirectUrl(path);
    };

    const handleSubmit = async formData => {
        if (formData.GroupID === 'n/a') {
            formData.GroupID = null;
        }

        const exportFormatKeys = Object.keys(formData).filter(key => ["Excel", "JSON", "XML", "CSV"].includes(key));
        const exportFormats = [];
        for (const key of exportFormatKeys) {
            if (formData[key]) {
                const exportFormat = {};
                switch (key) {
                    case "Excel":
                        exportFormat.xlsx = { individualAssets: !!formData?.individualExcelReports };
                        break;
                    case "JSON":
                        exportFormat.json = { individualAssets: !!formData?.individualJsonReports };
                        break;
                    case "XML":
                        exportFormat.xml = { individualAssets: !!formData?.individualXmlReports };
                        break;
                    case "CSV":
                        exportFormat.csv = { individualAssets: !!formData?.individualCsvReports };
                        break;
                }
                exportFormats.push(exportFormat);
            }
        }

        const outputModes = Object.keys(formData).filter(key => ["Download", "Email"].includes(key)).filter((key) => formData[key]);

        const data = new FormData();
        data.append('File', fileToSend.fileToSend);
        data.append('FileName', fileToSend.fileName);
        data.append('CollectionType', 'xls_collection');
        data.append('ExportFormats', JSON.stringify(exportFormats));
        data.append('OutputModes', outputModes.map(item => item.toLowerCase()));
        data.append('ActiveCustomerID', activeCustomerID);
        data.append('GroupID', formData.GroupID);
        data.append('generateNew', formData.generateNew);
        data.append('includeAggregatedPDFErasureReports', formData.includeAggregatedPDFErasureReports);
        data.append('includeAggregatedPDFVerificationReports', formData.includeAggregatedPDFVerificationReports);
        data.append('includeSummaryPDFErasureReports', formData.includeSummaryPDFErasureReports);
        data.append('includeSummaryPDFVerificationReports', formData.includeSummaryPDFVerificationReports);
        data.append('includeDiagnoseReports', formData.includeDiagnoseReports);
        data.append('includePDFReports', formData.includePDFReports);
        data.append('includeVerificationReports', formData.includeVerificationReports);

        let token = localStorage.getItem('SESSION');

        data.append('Token', token);
        let result = await onCreateNewXlsCollection(data);
        if (result) {
            setTimeout(() => {
                redirectHandler('/reports/erasure-reports#1');
            }, 1000);
        }
    };

    useEffect(() => {
        return () => {
            onClearState()
        };
    }, [onClearState]);


    useEffect(() => {
        const getGroups = async () => {
            setLoading(prevState => { return { ...prevState, groups: true } });
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_collies_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
                setLoading(prevState => { return { ...prevState, groups: false } });
            }
        }
        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomerID, permissions]);

    if (redirectUrl) {
        return <Redirect to={redirectUrl} />;
    };

    let formSettings = {
        Validation: {},
        FormTitle: translations["create_report_finder"] || "Create report finder",
        ButtonSubmit: hasPermission(permissions, "report_finder_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
        InitialValues: { GroupID: groups?.map(group => group.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null }
    };

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>;

    return (
        <Paper>
            {BackButton(translations)}
            {
                loading.groups ? loadingScreen :
                    <>
                        <ReportFinderForm
                            formSettings={formSettings}
                            handleSubmit={handleSubmit}
                            handleUpload={handleUpload}
                            fileName={fileToSend.fileName}
                            translations={translations}
                            groups={groups}
                        />
                        <Dialog
                            disableBackdropClick={true}
                            disableEscapeKeyDown={false}
                            open={reportFinder.snackStart}
                            PaperProps={{
                                classes: {
                                    root: classes.paper
                                }
                            }}
                        >
                            <div className={classes.div}>
                                <CircularProgress
                                    variant="static"
                                    color="primary"
                                    className={classes.circularProgress}
                                    size={300}
                                    value={reportFinder.progress ? reportFinder.progress > 100 ? 100 : reportFinder.progress : 0}
                                />
                                <Typography
                                    className={classes.typography}
                                    variant="h4"
                                >
                                    {reportFinder.progress ? reportFinder.progress > 100 ? 100 : reportFinder.progress : 0} %
                                </Typography>
                                <br></br>
                            </div>
                            <Typography
                                variant="h5"
                                className={classes.typographyTo}
                            >
                                {translations['do_not_refresh'] || 'Please do not refresh THIS page. Uploading...'}
                            </Typography>
                        </Dialog>
                    </>
            }
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        reportFinder: state.reports.reportFinder,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateNewReportFinder: reportFinder => dispatch(actions.createReportFinder(reportFinder)),
        onCreateNewXlsCollection: data => dispatch(actions.createXlsCollection(data)),
        onClearState: () => dispatch(actions.clearStateCreate()),
        onGetColumns: (data) => dispatch(reportActions.GetColumns(data)),
        onFetchCustomer: (id) => dispatch(reportActions.loadCustomers(id)),
        onExportExcel: (data) => dispatch(reportActions.downloadExcelReport(data)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ReportFinderCreate));